export const AcademicYearsQuery = {
  get: (locale: string): string => `query{
      anoLetivos(locale: "${locale}") {
        id
        ativo
        ano
        nome
        ativo_material
      }
    }
  `
};
